/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{c as o,g as c,f as s,n as r}from"../../chunks/vec3.js";import{c as t}from"../../chunks/vec3f64.js";import{projectVectorToVector as e}from"./projectVectorToVector.js";function f(t,f,a,p,i){o(m,t),c(n,t,f),e(m,a,m,i),e(n,a,n,i),s(p,n,m),r(p,p)}const m=t(),n=t();export{f as projectDirection};
